import { useRegisterSW } from 'virtual:pwa-register/react';
import { Knopf } from '@/components/ui';

/**
 * Aktualisierungshinweis der PWA (PHASENPLAN 1.10).
 *
 * Bewusst nicht automatisch: Während einer laufenden Erfassung würde ein
 * stiller Neustart die Arbeit unterbrechen. Der Nutzer entscheidet, wann.
 */
export const PwaAktualisierung = () => {
  const {
    offlineReady: [offlineBereit, setOfflineBereit],
    needRefresh: [aktualisierungNoetig, setAktualisierungNoetig],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_pfad, registrierung) {
      // Stündlich nachsehen, ob es eine neue Version gibt.
      if (registrierung) {
        setInterval(() => void registrierung.update(), 60 * 60 * 1000);
      }
    },
  });

  if (!offlineBereit && !aktualisierungNoetig) return null;

  const schliessen = (): void => {
    setOfflineBereit(false);
    setAktualisierungNoetig(false);
  };

  return (
    <div
      role="status"
      className="nicht-drucken fixed inset-x-3 bottom-3 z-50 mx-auto max-w-md rounded-xl bg-slate-900 p-4 text-white shadow-lg sm:inset-x-auto sm:right-4"
    >
      {aktualisierungNoetig ? (
        <>
          <p className="text-sm font-medium">Eine neue Version steht bereit.</p>
          <p className="mt-1 text-sm text-slate-300">
            Sie wird beim nächsten Neuladen aktiv. Laufende Eingaben bleiben gespeichert.
          </p>
          <div className="mt-3 flex gap-2">
            <Knopf groesse="klein" onClick={() => void updateServiceWorker(true)}>
              Jetzt neu laden
            </Knopf>
            <Knopf groesse="klein" aussehen="still" className="text-white" onClick={schliessen}>
              Später
            </Knopf>
          </div>
        </>
      ) : (
        <div className="flex items-center justify-between gap-3">
          <p className="text-sm">Die App ist jetzt offline einsatzbereit.</p>
          <Knopf groesse="klein" aussehen="still" className="text-white" onClick={schliessen}>
            Verstanden
          </Knopf>
        </div>
      )}
    </div>
  );
};
